import { classNames } from '@dimjs/utils';
import { CommonPropsWithChildren } from '../utils';
import { getZIndex } from '../utils/z-index';
import { LoadingAnimation } from './animation';

export type SpinnerProps = CommonPropsWithChildren & {
  spinning: boolean;
  indicator?: JSX.Element;
};

const Animation = (props: SpinnerProps) => {
  return <>{props.indicator ? props.indicator : <LoadingAnimation />}</>;
};

export const Spinner = (props: SpinnerProps) => {
  return (
    <>
      {props.spinning ? (
        <div
          className={classNames('v-full-loading', props.className)}
          style={{ zIndex: getZIndex(), ...props.style }}
        >
          <Animation {...props} />
        </div>
      ) : null}
      {props.children}
    </>
  );
};
